import { useQuery } from '@tanstack/react-query';

import { Company, type CompanyId } from 'common/api/api-types';
import { deliveryOsGatewayApiAgent } from 'common/api/apiAgents';
import queryKeys from 'common/hooks/queryKeys';
import { decodeHttpResponse } from 'common/utils';

const fetchCompanyByCompanyId = ({ companyId }: { companyId?: CompanyId }) =>
  companyId
    ? decodeHttpResponse(Company, deliveryOsGatewayApiAgent.get(`/companies/${companyId}`))
    : Promise.reject('ERROR: Failed to fetch the company. The company ID is falsy');

const useCompanyByCompanyId = <SelectData = Company>({
  companyId,
  select,
}: {
  companyId?: CompanyId;
  select?: (data: Company) => SelectData;
}) =>
  useQuery({
    queryKey: queryKeys.forUseCompanyByCompanyId({ companyId }),
    queryFn: () =>
      fetchCompanyByCompanyId({
        companyId,
      }),
    select,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    enabled: Boolean(companyId),
    placeholderData: previousData => previousData,
  });

export default useCompanyByCompanyId;
